import { useContext, useMemo } from 'react';
import { getClient } from '@resolve-js/client';
import { assertContext, ResolveContext } from './context';

var useClient = function useClient() {
  var context = useContext(ResolveContext);
  assertContext(context);
  return useMemo(function () {
    return getClient(context);
  }, [context]);
};

export { useClient };
//# sourceMappingURL=use-client.js.map